import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import GiftPackage from '../entities/gift-package'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';

interface GiftPackageState extends ListState<GiftPackage>{
    editGiftPackage:GiftPackage;
    permissions:Array<string>
}
class GiftPackageModule extends ListModule<GiftPackageState,any,GiftPackage>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<GiftPackage>(),
        loading:false,
        editGiftPackage:new GiftPackage(),
        permissions:new Array<string>()
    }
    actions={
        async getAll(context:ActionContext<GiftPackageState,any>,payload:any){
            context.state.loading=true;
            let response=await Ajax.get('/api/services/app/GiftPackage/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=response.data.result as PageResult<GiftPackage>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<GiftPackageState,any>,payload:any){
            context.state.loading=true;
            await Ajax.post('/api/services/app/GiftPackage/Create',payload.data);
            context.state.loading=false;
        },
        async update(context:ActionContext<GiftPackageState,any>,payload:any){
            context.state.loading=true;
            await Ajax.put('/api/services/app/GiftPackage/Update',payload.data);
            context.state.loading=false;
        },
        async delete(context:ActionContext<GiftPackageState,any>,payload:any){
            context.state.loading=true;
            await Ajax.delete('/api/services/app/GiftPackage/Delete?Id='+payload.data.id);
            context.state.loading=false;
        },
        async get(context:ActionContext<GiftPackageState,any>,payload:any){
            let response=await Ajax.get('/api/services/app/GiftPackage/Get?Id='+payload.id);
            return response.data.result as GiftPackage;
        },
        async getAllPermissions(context:ActionContext<GiftPackageState,any>){
            let response=await Ajax.get('/api/services/app/GiftPackage/getAllPermissions');
            context.state.permissions=response.data.result.items;
        }
    };
    mutations={
        setCurrentPage(state:GiftPackageState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:GiftPackageState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:GiftPackageState,giftPackage:GiftPackage){
            state.editGiftPackage=giftPackage;
        }
    }
}
const giftPackageModule=new GiftPackageModule();
export default giftPackageModule;